// Copyright (c) Docugami, Inc. All rights reserved.

export enum LoggerCategory {
    CanvasSelection = 'CanvasSelection',
    AssistedAuthoring = 'AssistedAuthoring',
    Dgml = 'Dgml',
    Downloader = 'Downloader',
    Telemetry = 'Telemetry',
    Authentication = 'Authentication',
    Network = 'Network',
    FileManager = 'FileManager',
    SignalR = 'SignalR',
    Tokens = 'Tokens',
    Feedback = 'Feedback',
    Billing = 'Billing',
    Chat = 'Chat'
}

export enum LoggerLevel {
    Critical,
    Error,
    Warning,
    Information,
    Log,
    Debug,
    Trace
}

export type LoggerLevelConfig = {
    [key in LoggerCategory | "Default"]?: LoggerLevel;
}

export class Logger {
    public static config: LoggerLevelConfig = {
        Default: LoggerLevel.Error
    }

    public static LogCritical(category: LoggerCategory, msg: string, error?: any) {
        if (Logger.LevelEnabledForCategory(category, LoggerLevel.Critical)) {
            console.error(msg, error);
        }
    }

    public static LogError(category: LoggerCategory, msg: any, error?: any) {
        if (Logger.LevelEnabledForCategory(category, LoggerLevel.Error)) {
            console.error(msg, error);
        }
    }

    public static LogWarning(category: LoggerCategory, msg: any) {
        if (Logger.LevelEnabledForCategory(category, LoggerLevel.Warning)) {
            console.warn(msg);
        }
    }

    public static LogInformation(category: LoggerCategory, msg: any) {
        if (Logger.LevelEnabledForCategory(category, LoggerLevel.Information)) {
            console.info(msg);
        }
    }

    public static Log(category: LoggerCategory, msg: any) {
        if (Logger.LevelEnabledForCategory(category, LoggerLevel.Debug)) {
            console.log(msg);
        }
    }

    public static LogDebug(category: LoggerCategory, msg: any) {
        if (Logger.LevelEnabledForCategory(category, LoggerLevel.Debug)) {
            console.debug(msg);
        }
    }

    public static LogTrace(category: LoggerCategory, msg: any) {
        if (Logger.LevelEnabledForCategory(category, LoggerLevel.Trace)) {
            console.trace(msg);
        }
    }

    private static LevelEnabledForCategory(category: LoggerCategory, level: LoggerLevel): boolean {
        const configForCategory = Logger.config[category] ?? Logger.config["Default"]!;
        return level <= configForCategory;
    }
}
